// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2URyc","topBottomGutter":"Layout_topBottomGutter__3Tsfr"};